import React, { useState, useEffect, useContext } from "react";
import getAllHijirDate from "./function/getAllHijriDate";

import "./App.css";
import "./styles/Texture.css";
import "./styles/CustomFont.css";
import StoreProvider, { Store } from "./state/state";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Templete from "./components/Templete";
import Page404 from "./pages/Page404";
import Home from "./pages/Home";
import Guide from "./pages/Guide";
function App() {
  return (
    <StoreProvider>
      <Router>
        <Switch>
          <Route exact path="/" component={Home}></Route>
          <Route path="/template">
            <Templete />
          </Route>
          <Route component={Page404}></Route>
        </Switch>
      </Router>
    </StoreProvider>
  );
}

export default App;
